import { Menu, MenuItem } from '@mui/material';
import { FilterOption, SortOption } from '@tassat/ui-definitions';
import * as React from 'react';

import muiStyles from './styles';
import { DropdownMenuProps } from './types';
import { NON_ALPHANUMERIC_REGEX } from '../types';

export default function DropdownMenu(props: DropdownMenuProps) {
    const {
        id,
        menuAnchor,
        handleMenuClose,
        menuModel,
        onSelect,
        MenuItemComponent
    } = props;

    const classes = muiStyles(props);

    return (
        <Menu
            anchorEl={menuAnchor}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
            }}
            id='sort-menu'
            keepMounted
            onClose={handleMenuClose}
            open={Boolean(menuAnchor)}
            PopoverClasses={{ paper: classes.root }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
            }}
        >
            {
                menuModel.options.map((option: SortOption | FilterOption, i) => (
                    <MenuItem
                        id={`${id}_${option.title.replace(NON_ALPHANUMERIC_REGEX, '')}`}
                        key={`${i}_${option.colId}`} // eslint-disable-line react/no-array-index-key
                        onClick={() => {
                            onSelect(option);
                            handleMenuClose();
                        }}
                    >
                        <MenuItemComponent
                            currentModel={menuModel.currentModel}
                            option={option}
                        />
                    </MenuItem>
                ))
            }
        </Menu>
    );
}